<template>
  <div class="card p-4">
    <h4>Professores</h4>

    <teacher-item
      v-for="item of teachers"
      :key="item.id"
      :teacher="item"
      :course="course"
      @reloadTeachers="reloadTeachers()"
    />

    <teacher-item
      :course="course"
      @reloadTeachers="reloadTeachers()"
    />
  </div>
</template>

<script>
import Axios from 'axios'
import TeacherItem from './Teachers/index'

export default {
  props: {
    course: {
      required: true
    }
  },
  components: {
    "teacher-item": TeacherItem
  },
  watch: {
    course: {
      immediate: true,
      handler: function(val, old) {
        if(val != undefined) {
          this.reloadTeachers()
        }
      }
    }
  },
  data() {
    return {
      teachers: []
    }
  },
  methods: {
    reloadTeachers: function() {
      Axios.get('/teacher/course/teacher', {
        params: {
          'course': this.course
        }
      })
        .then( res => {
          this.teachers = res.data.data
        })
    }
  }
}
</script>

<style>

</style>
